import { USERDELETE_URLS } from '../../config/config'
import { UserAPICall, UserRequest } from './UserRequestUtil'

export const UserDelete = async (type,param) =>{
  const url = USERDELETE_URLS[type];
  const parameter = {
    username: param.uid,
  }
  const res = await UserAPICall(url,parameter);

  return res;
};
